import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  GetAiModelResponse,
  NewModelPost
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  params: NewModelPost
  onSuccess: (response: GetAiModelResponse) => void
  children?: (response: GetAiModelResponse) => ReactElement
}

const CreateAiModelRequest = ({
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/models`

  const { requestParams } = useGetParamsWithSpaceId<NewModelPost>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default CreateAiModelRequest
